const sameGroup = (row, sku) => row.sku === sku || Boolean(row.lookup?.split(';').includes(sku));

const groupRating = (ratings, sku) => {
  const rows = (ratings || []).filter(row => sameGroup(row, sku));
  const unique = rows.filter(
    (row, index) => rows.findIndex(other => other.sku === row.sku) === index
  );
  const total = unique.reduce((sum, row) => sum + (Number(row.num_ratings) || 0), 0);
  if (!total) return null;
  const weighted = unique.reduce(
    (sum, row) => sum + (parseFloat(row.average_rating) || 0) * (Number(row.num_ratings) || 0),
    0
  );
  return { average: weighted / total, total };
};

export const ratingFor = (product, ratings) => {
  const match = (product?.shopifyData?.variants || [])
    .map(variant => variant.sku)
    .filter(Boolean)
    .map(sku => groupRating(ratings, sku))
    .find(Boolean);
  return { averageRating: match?.average || 0, numRatings: match?.total || 0 };
};

export default groupRating;
